import { getAllUrlParams } from "utils/utils";

export const CUSTOMER_VIEWS = {
  GLOBAL: "global",
  COMMANDES: "commandes",
  PORTE_MONNAIE: "porte-monnaie",
  AVANTAGES: "avantages",
  TRANSACTIONS: "transactions",
};

const VALID_VUES = new Set(Object.values(CUSTOMER_VIEWS));

export const normalizeCustomerVue = (vue) => {
  if (!vue || vue === CUSTOMER_VIEWS.GLOBAL) {
    return CUSTOMER_VIEWS.GLOBAL;
  }
  return VALID_VUES.has(vue) ? vue : CUSTOMER_VIEWS.GLOBAL;
};

export const buildCustomerSearch = (customerId, vue = CUSTOMER_VIEWS.GLOBAL) => {
  const params = new URLSearchParams();
  if (customerId) {
    params.set("customerId", String(customerId));
  }
  const normalizedVue = normalizeCustomerVue(vue);
  if (normalizedVue !== CUSTOMER_VIEWS.GLOBAL) {
    params.set("vue", normalizedVue);
  }
  return params.toString() ? `?${params.toString()}` : "";
};

export const CUSTOMER_URL_SYNC_MESSAGE = "store_customers_url_sync";

export const parseCustomerDeepLink = (search) => {
  const params = getAllUrlParams(search);
  return {
    customerId: params.customerid || null,
    vue: normalizeCustomerVue(params.vue),
  };
};

/**
 * URL BO Symfony (page qui embarque l'iframe React clients).
 * @param {string} adminBaseUrl ex. https://localhost:8000/e28XmZh3
 */
export const buildSymfonyCustomersUrl = (
  adminBaseUrl,
  customerId,
  vue = CUSTOMER_VIEWS.GLOBAL
) => {
  const base = `${adminBaseUrl.replace(/\/$/, "")}/store/customers/`;
  const search = buildCustomerSearch(customerId, vue);
  return `${base}${search}`;
};

export const notifyParentCustomerUrl = (search = "") => {
  const parentOrigin = process.env.REACT_APP_LEMOULIN_BO_URL;
  if (!parentOrigin || window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      type: CUSTOMER_URL_SYNC_MESSAGE,
      search: search || "",
    },
    parentOrigin
  );
};
